module.exports = vendors_en_223696075754bde17cd7;